import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  OutlinedInput,
  Stack,
  TextField,
} from "@mui/material";
import {
  DataGridPremium,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  useGridApiRef,
} from "@mui/x-data-grid-premium";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { postRequest } from "services/api";
import "../../css/pages/bolReports.css";
import PDFViewer from "components/PDFViewer";
import SignatureCanvas from "react-signature-canvas";
import { PDFDocument } from "pdf-lib";
import CheckIcon from "@mui/icons-material/Check";
import { apiEndPoint } from "services";
import DateRangePicker from "react-bootstrap-daterangepicker";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import moment from "moment";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const columns = [
  {
    field: "OrderNumber",
    headerClassName: "headingbg-color",
    headerName: "IGD Order",
    flex: 1,
  },
  {
    field: "Owner",
    headerClassName: "headingbg-color",
    headerName: "Owner",
  },
  {
    field: "Warehouse",
    headerClassName: "headingbg-color",
    headerName: "Warehouse",
  },
  {
    field: "ExternalOrderNo",
    headerClassName: "headingbg-color",
    headerName: "Customer Order",
  },
  {
    field: "PurchaseOrder",
    headerClassName: "headingbg-color",
    headerName: "Customer PO Number",
  },
  
  {
    field: "LoadNumber",
    headerClassName: "headingbg-color",
    headerName: "Load Number",
  },
  {
    field: "BLNumber",
    renderCell: (params) => {
      if (params.row.signedBOLFile || params.row.sourceBOLFile) {
        return (
          <Link href="#">
            {params.value ? params.value.toString() : "View File"}
          </Link>
        );
      } else {
        return params.value && params.value.toString();
      }
    },
    headerClassName: "headingbg-color",
    headerName: "BOL Number",
    flex: 1,
  },
  {
    field: "MBOLNumber",
    headerClassName: "headingbg-color",
    headerName: "MBOL Number",
    flex: 1,
  },
  // {
  //   field: "UploadMultiFile",
  //   renderCell: (params) => (
  //     <Button
  //       fullWidth
  //       variant="contained"
  //       sx={{ mt: 0, mb: 0, fontSize: "11px" }}
  //       //onClick={() => setFormDialog(true)}
  //     >
  //       Upload Files
  //     </Button>
  //   ),
  //   width: 120,
  //   headerClassName: "headingbg-color",
  //   headerName: "Upload File",
  // },
  {
    field: "digitalSign",
    renderCell: (params) => {
      if (params.row.showSignBtn === 1) {
        return (
          <Button variant="contained" sx={{ mt: 0, mb: 0, fontSize: "11px" }}>
            Sign Here
          </Button>
        );
      }
    },

    headerClassName: "headingbg-color",
    headerName: "Digital Signature",
  },
  {
    field: "digitalReSign",
    renderCell: (params) => {
      if (params.row.showSignBtn === 1) {
        return (
          <Button variant="contained" sx={{ mt: 0, mb: 0, fontSize: "11px" }}>
            Re Signature
          </Button>
        );
      }
    },

    headerClassName: "headingbg-color",
    headerName: "Re Signature",
    flex: 1.6,
  },
  // { field: 'BLNumber', headerClassName: "headingbg-color", width: 180, headerName: 'BL Number' },
  // { field: 'BLStatus', headerClassName: "headingbg-color", headerName: 'BL Status' },
  {
    field: "OrderType",
    headerClassName: "headingbg-color",
    headerName: "Order Type",
    flex: 1,
  },

  {
    field: "CarrierCode",
    headerClassName: "headingbg-color",
    headerName: "SCAC",
    flex: 1,
  },
  {
    field: "CarrierName",
    headerClassName: "headingbg-color",
    headerName: "Carrier Name",
    flex: 1,
  },
  // { field: 'FreightPaymentType', headerClassName: "headingbg-color", headerName: 'Freight Payment Type' },
  // { field: 'sourceBOLFile', width: 200, headerClassName: "headingbg-color", headerName: 'source BOL File' },

  {
    field: "Tracking_PROnumber",
    headerClassName: "headingbg-color",
    headerName: "Tracking/PRO",
    flex: 1,
  },
  // {
  //     field: 'UploadFile',
  //     renderCell: (params) => (
  //         <Link href="#">
  //             <input type="file" accept=".pdf" onChange={handleFileChange} />
  //             Upload File</Link>),
  //     width: 280, headerClassName: "headingbg-color", headerName: 'Upload File'
  // },
];

const mainColumns = [
  {
    field: "Owner",
    headerClassName: "headingbg-color",
    headerName: "Owner",
    flex: 1,
  },
  {
    field: "Warehouse",
    headerClassName: "headingbg-color",
    headerName: "Warehouse",
    flex: 1,
  },
  {
    field: "OrderNumber",
    headerClassName: "headingbg-color",
    headerName: "IGD Order",
    flex: 1,
  },
  {
    field: "ExternalOrderNo",
    headerClassName: "headingbg-color",
    headerName: "Customer Order",
    flex: 1,
  },
  {
    field: "OrderType",
    headerClassName: "headingbg-color",
    headerName: "Order Type",
    flex: 1,
  },
  {
    field: "PurchaseOrder",
    headerClassName: "headingbg-color",
    headerName: "Customer PO Number",
    flex: 1,
  },
  {
    field: "CarrierCode",
    headerClassName: "headingbg-color",
    headerName: "SCAC",
    flex: 1,
  },
];

const EsignBolTable = () => {
  const apiRef = useGridApiRef();
  const apiRefManual = useGridApiRef();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const { startDate, endDate } = useSelector((state) => state.dashboard);
  const { user, userSetting } = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);
  const [orderNo, setOrderNo] = useState("");
  const [isSigned, setIsSigned] = useState(0);
  const [signedFileName, setsignedFileName] = useState("");
  const [bolNo, setBolNo] = React.useState("");
  const [mBolNo, setMbolNo] = React.useState("");
  const [loadNo, setLoadNo] = React.useState("");
  const [openSignature, setOpenSignature] = useState(false);
  const [uploadSignDialog, setUploadSignDialog] = useState(false);
  const [formDialog, setFormDialog] = useState(false);
  const signatureCanvasRef = useRef(null);
  const signatureCanvasRef2 = useRef(null);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [dataSaved, setDataSaved] = useState(false);
  const [bolError, setBolError] = useState(false);
  const [mBolError, setMbolError] = useState(false);
  const [mbolFile, setmBolFile] = useState(null);
  const [fileBols, setFileBols] = useState(null);
  const [manualFile, setManualFile] = useState(null);
  const [clearFormData, setClearFormData] = useState(false);
  const [loadDate, setLoadDate] = useState({
    fromDate: moment().subtract(1, "month").startOf("month").toDate(),
    toDate: moment().toDate(),
  });
  const [isErrorMsg, setisErrorMsg] = useState(false);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [rowsData, setRowsData] = useState([]);

  const [owner, setOwner] = useState("");
  const [wareHouse, setWareHouse] = useState("");

  const [poNumber, setPoNumber] = useState("");
  const [bolNumber, setBolNumber] = useState("");
  const [loadId, setLoadId] = useState("");
  const [isDisabled, setIsDisabled] = useState(false)

  const labelLoadDate = loadDate.fromDate
    ? moment(loadDate.fromDate).format("MMMM D, YYYY") +
      " - " +
      moment(loadDate.toDate).format("MMMM D, YYYY")
    : "Select Load date";

  const handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    fetchTableData();
  };

  const fetchTableData = async () => {
    setIsLoading(true);
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user?.token}`,
    };
    let payload = {
      custCode: user?.userType === 'Admin' ||  user?.userType === 'Admin0' ? "all" : userSetting?.[0]?.currCustomer, //userSetting?.[0]?.currCustomer,
      whseCode: userSetting?.[0]?.currWarehouse,
      carrier: "all",
      status: "all",
      fromDate: loadDate.fromDate
        ? moment(loadDate.fromDate).format("YYYY-MM-DD")
        : "",
      toDate: loadDate.toDate
        ? moment(loadDate.toDate).format("YYYY-MM-DD")
        : "",
      POnum: poNumber ? poNumber : 'all',
      BOLnum: bolNumber ? bolNumber : 'all',
      loadID: loadId ? loadId : 'all',
      userID :user?.userType === 'Admin' ||  user?.userType === 'Admin0' ? '' : user?.Id,
    };
    const response = await postRequest(
      "user/getRprt_billOfLadingDtls",
      payload,
      headers
    );
    setData(response.data.Payload);
    setClearFormData(false);
    setIsLoading(false);
  };

  useEffect(() => {
    if (clearFormData) {
      fetchTableData();
    }
  }, [clearFormData]);

  const clearForm = () => {
    setLoadDate({
      fromDate: moment().subtract(1, "month").startOf("month").toDate(),
      toDate: moment().toDate(),
    });
    setPoNumber('');
    setBolNumber('');
    setLoadId('');
    setClearFormData(true);
  };

  const handleCallback = (start, end) => {
    setLoadDate({ fromDate: start, toDate: end });
  };

  useEffect(() => {
    fetchTableData();
  }, [startDate, endDate, userSetting]);

  useEffect(() => {
    const rows = data.map((c, index) => ({
      id: index,
      OrderNumber: c.OrderNumber,
      BLNumber: c.BLNumber,
      BLStatus: c.BLStatus,
      OrderType: c.OrderType,
      BillTo: c.BillTo,
      ShipTo: c.ShipTo,
      CarrierCode: c.CarrierCode,
      CarrierName: c.CarrierName,
      FreightPaymentType: c.FreightPaymentType,
      Tracking_PROnumber: c.Tracking_PROnumber,
      sourceBOLFile: c.sourceBOLFile,
      SealNumber: c.SealNumber,
      isBOLSigned: c.isBOLSigned,
      signedBOLFile: c.signedBOLFile,
      MBOLNumber: c.MBOLNumber,
      ExternalOrderNo: c.ExternalOrderNo,
      PurchaseOrder: c.PurchaseOrder,
      LoadNumber: c.LoadNumber,
      showSignBtn: c.showSignBtn,
      Owner: c.Owner,
      Warehouse: c.Warehouse,
    }));

    setRowsData(rows);
  }, [data]);

  const handleCellSelectionModelChange = useCallback((newModel) => {
    Object.entries(newModel).forEach(([id, fields]) => {
      const updatedRow = apiRef.current.getRow(id);
      if (fields.BLNumber) {
        setOrderNo(updatedRow.OrderNumber);
        setIsSigned(updatedRow.isBOLSigned);
        const filepath = `${apiEndPoint}/`;
        setsignedFileName(filepath + updatedRow.signedBOLFile);
        if (updatedRow.isBOLSigned) {
          setOpen(true);
        } else {
          if (updatedRow.sourceBOLFile) {
            setsignedFileName(filepath + updatedRow.sourceBOLFile);
            setOpen(true);
          }
        }
      } else if (fields.digitalSign && updatedRow.showSignBtn === 1) {
        if (!updatedRow.sourceBOLFile) {
          return;
        }
        setisErrorMsg(false);
        setOrderNo(updatedRow.OrderNumber);
        setBolNo(updatedRow.BLNumber);
        setLoadNo(updatedRow.LoadNumber);
        setOwner(updatedRow.Owner);
        setWareHouse(updatedRow.Warehouse);
        setIsSigned(updatedRow.isBOLSigned);
        const filepath = `${apiEndPoint}/`;
        setsignedFileName(filepath + updatedRow.sourceBOLFile);
        if (updatedRow.isBOLSigned) {
          setsignedFileName(filepath + updatedRow.signedBOLFile);
          setOpenSignature(true);
        } else {
          setsignedFileName(filepath + updatedRow.sourceBOLFile);
          setOpenSignature(true);
        }
      } else if (fields.digitalReSign && updatedRow.showSignBtn === 1) {
        if (!updatedRow.sourceBOLFile) {
          return;
        }
        setisErrorMsg(true);
        setOrderNo(updatedRow.OrderNumber);
        setBolNo(updatedRow.BLNumber);
        setLoadNo(updatedRow.LoadNumber);
        setOwner(updatedRow.Owner);
        setWareHouse(updatedRow.Warehouse);
        setIsSigned(updatedRow.isBOLSigned);
        const filepath = `${apiEndPoint}/`;
        setsignedFileName(filepath + updatedRow.sourceBOLFile);
        if (updatedRow.isBOLSigned) {
          setOpenSignature(true);
        } else {
          setsignedFileName(filepath + updatedRow.sourceBOLFile);
          setOpenSignature(true);
        }
      } else if (fields.UploadMultiFile) {
        setOrderNo(updatedRow.OrderNumber);
        setBolNo(updatedRow.BLNumber);
        setMbolNo(updatedRow.MBOLNumber);
        setIsSigned(updatedRow.isBOLSigned);
        const filepath = `${apiEndPoint}/`;
        setsignedFileName(filepath + updatedRow.signedBOLFile);
        setFormDialog(true);
        setBolError(false);
        setError(false);
      } else {
        return;
      }
    });

    // setCellSelectionModel(newModel);
  }, []);

  const handleClearSignature = () => {
    signatureCanvasRef.current?.clear();
    signatureCanvasRef2.current?.clear();
  };

  const handleSavePDF = async () => {
    if (
      (!signatureCanvasRef.current || signatureCanvasRef.current.isEmpty()) &&
      (!signatureCanvasRef2.current || signatureCanvasRef2.current.isEmpty())
    ) {
      alert("Please provide a signature.");
      return;
    }

    setIsDisabled(true);
    const isSignLeft = !signatureCanvasRef2.current.isEmpty();
    const isSignRight = !signatureCanvasRef.current.isEmpty();
    var pdfToSign = signedFileName;
    const signatureImageLeft = isSignLeft
      ? signatureCanvasRef2.current.toDataURL()
      : null;
    const signatureImageRight = isSignRight
      ? signatureCanvasRef.current.toDataURL()
      : null;

    const existingPdfBytes = await fetch(pdfToSign).then((res) =>
      res.arrayBuffer()
    );
    const bytes = new Uint8Array(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(bytes);

    const pages = await Promise.all(
      Array.from(Array(pdfDoc.getPageCount()).keys()).map(async (pageIndex) => {
        const page = await pdfDoc.getPage(pageIndex);
        if (signatureImageLeft) {
          const pngImage = await pdfDoc.embedPng(signatureImageLeft);
          const pngDims = pngImage.scale(0.35); // Adjust scale if needed
          //const splitName = pdfToSign.split("_");
          page.drawImage(pngImage, {
            x: 50, // Adjust x and y coordinates to position the signature
            y: 40,
            width: pngDims.width,
            height: pngDims.height,
          });
        }

        if (signatureImageRight) {
          const pngImage = await pdfDoc.embedPng(signatureImageRight);
          const pngDims = pngImage.scale(0.35); // Adjust scale if needed
          //const splitName = pdfToSign.split("_");
          page.drawImage(pngImage, {
            x: 370, // Adjust x and y coordinates to position the signature
            y: 60,
            width: pngDims.width,
            height: pngDims.height,
          });
        }

        // if (splitName[3] === "null") {
        //   page.drawImage(pngImage, {
        //     x: 380, // Adjust x and y coordinates to position the signature
        //     y: 150,
        //     width: pngDims.width,
        //     height: pngDims.height,
        //   });
        // } else {
        //   if (pageIndex === 0) {
        //     page.drawImage(pngImage, {
        //       x: 380, // Adjust x and y coordinates to position the signature
        //       y: 110,
        //       width: pngDims.width,
        //       height: pngDims.height,
        //     });
        //   } else {
        //     page.drawImage(pngImage, {
        //       x: 380, // Adjust x and y coordinates to position the signature
        //       y: 150,
        //       width: pngDims.width,
        //       height: pngDims.height,
        //     });
        //   }
        // }
      })
    );

    const modifiedPdfBytes = await pdfDoc.save();
    const file = new File(
      [modifiedPdfBytes],
      `signedPDF_${orderNo}_${bolNo}.pdf`,
      { type: "application/pdf" }
    );
    uploadSignedFile(file);
  };

  const uploadSignedFile = async (file) => {
    const responseFile = await UploadSignedMbolFile({
      custCode: owner,
      whseCode: wareHouse,
      loadNo: loadNo,
      bolNumber: bolNo,
      file: file,
    });

    if (responseFile) {
      var msg =
        responseFile.data.Message != null
          ? responseFile.data.Message
          : responseFile.data.errors != null
          ? responseFile.data.errors[""][0]
          : responseFile.data.title;
      alert(msg);
      setOpenSignature(false);
      window.location.reload();
    }
  };

  const UploadSignedMbolFile = async (params) => {
    const formData = new FormData();

    formData.append("file", params.file);
    formData.append("bolNumber", params.bolNumber);
    formData.append("loadID", params.loadNo);
    formData.append("custCode", params.custCode);
    formData.append("whseCode", params.whseCode);
    let headers = {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${user?.token}`,
    };

    const response = await postRequest(
      "user/UploadSignedMBOLfile2",
      formData,
      headers
    );
    return response;
  };

  const handleBolFiles = (event) => {
    setFileBols(event.currentTarget.files[0]);
  };

  const handleMbolFile = (event) => {
    setmBolFile(event.currentTarget.files[0]);
  };

  const isDuplicateBolNumber = (rows, value) => {
    const findDuplicate = rows.filter((row) => row.BLNumber === value);
    if (findDuplicate.length > 1) {
      return true;
    } else {
      return false;
    }
  };

  const isDuplicateMBolNumber = (rows, value) => {
    const findDuplicate = rows.filter((row) => row.BLNumber === value);
    if (findDuplicate.length > 1) {
      return true;
    } else {
      return false;
    }
  };

  const handleBolNumber = (e) => {
    setBolNo(e.target.value);
    if (isDuplicateBolNumber(rowsData, e.target.value)) {
      setBolError(true);
    } else if (e.target.value === "") {
      setBolError(true);
    } else {
      setBolError(false);
    }
  };

  const handleMbolNumber = (e) => {
    setMbolNo(e.target.value);
    if (isDuplicateMBolNumber(rowsData, e.target.value)) {
      setMbolError(true);
    } else {
      setMbolError(false);
    }
  };

  const validateForm = () => {
    let isValid = false;
    let message = "";

    if (mBolNo && mbolFile) {
      isValid = false;
    } else if (!mBolNo && !mbolFile) {
      isValid = false;
    } else {
      isValid = true;
      message = "Please fill both Mbol number and upload Mbol files";

      setError(isValid);
      setErrorMessage(message);
      return isValid;
    }

    if (bolNo && fileBols) {
      isValid = false;
    } else {
      isValid = true;
      message = "Please fill both Bol number and upload Bol files";

      setError(isValid);
      setErrorMessage(message);
      return isValid;
    }

    return isValid;
  };

  const save_BOL_MBOL_NUMBER = async () => {
    let payload = {
      custCode: userSetting?.[0]?.currCustomer,
      whseCode: userSetting?.[0]?.currWarehouse,
      orderKey: orderNo,
      bolNumber: bolNo,
      mBolNumber: mBolNo,
    };
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user?.token}`,
    };
    const response = await postRequest(
      "gpuser/save_ordersBolMbolDtls",
      payload,
      headers
    );
    return response;
  };

  const UploadMultipleUnSignedMbolFile = async (fileMbol, fileBols) => {
    const formData = new FormData();
    formData.append("custCode", userSetting?.[0]?.currCustomer);
    formData.append("whseCode", userSetting?.[0]?.currWarehouse);
    formData.append("fileMbol", fileMbol);

    formData.append("fileBols", fileBols);

    formData.append("bolNumber", bolNo);
    formData.append("mBolNumber", mBolNo);
    let headers = {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${user?.token}`,
    };

    const response = await postRequest(
      "user/UploadUnSignedBOLMBOLfile",
      formData,
      headers
    );

    return response;
  };

  const handleUploadMultiFiles = async (e) => {
    e.preventDefault();
    const validate = validateForm();
    if (!validate) {
      const saveBOL_MBOL_number = await save_BOL_MBOL_NUMBER();
      if (saveBOL_MBOL_number) {
        const responseFile = await UploadMultipleUnSignedMbolFile(
          mbolFile,
          fileBols
        );
        if (responseFile) {
          var msg =
            responseFile.Message != null
              ? responseFile.Message
              : responseFile.errors != null
              ? responseFile.errors[""][0]
              : responseFile.title;

          setDataSaved(true);

          window.setTimeout(() => {
            setDataSaved(false);
            setFormDialog(false);
            window.location.reload();
          }, 1500);
        }
      }
    }
  };

  const handleManualFile = (e) => {
    setManualFile(e.currentTarget.files[0]);
  };

  useEffect(() => {
    if (rowSelectionModel.length === 0) {
      setManualFile(null);
    }
  }, [rowSelectionModel]);

  const uploadManualFile = async (e) => {
    e.preventDefault();
    if (!manualFile) {
      alert("Please Select a File");
      return;
    }
    setIsDisabled(true)
    const formData = new FormData();

    formData.append("file", manualFile);
    let selectedRows = apiRefManual.current.getSelectedRows();
    let pushedArrayToString = [];
    let owner = "";
    let wareHouse = "";
    for (let [key, value] of selectedRows) {
      console.log(key + " is " + value);
      pushedArrayToString.push(value.OrderNumber);
      owner = value.Owner;
      wareHouse = value.Warehouse;
    }

    if (pushedArrayToString.length < 1) {
      alert("Please select at least one order");
      return;
    }

    formData.append("custCode", owner);
    formData.append("whseCode", wareHouse);

    formData.append("orderKeys", pushedArrayToString);

    let headers = {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${user?.token}`,
    };

    const response = await postRequest(
      "user/UploadManuallySignedMbolFile",
      formData,
      headers
    );

    window.location.reload();
  };

  // const CustomToolbarManual = useCallback(
  //   (props) => {
  //     return (
  //       <GridToolbarContainer {...props}>
  //         <GridToolbarColumnsButton
  //           slotProps={{ button: { sx: { fontSize: "14px" } } }}
  //         />
  //         <GridToolbarFilterButton
  //           slotProps={{ button: { sx: { fontSize: "14px" } } }}
  //         />
  //         <GridToolbarDensitySelector
  //           slotProps={{ button: { sx: { fontSize: "14px" } } }}
  //         />
  //         {/* <GridToolbarExport /> */}
  //         <GridToolbarExport
  //           slotProps={{ button: { sx: { fontSize: "14px" } } }}
  //         />

  //         <Box sx={{ display: "flex" }}>
  //           <TextField
  //             type="file"
  //             variant="outlined"
  //             inputProps={{ multiple: false, accept: "application/pdf" }}
  //             onChange={handleManualFile}
  //           />
  //           <Button onClick={uploadManualFile}>Upload</Button>
  //         </Box>
  //         <Box sx={{ flexGrow: 1 }} />
  //         <GridToolbarQuickFilter />
  //       </GridToolbarContainer>
  //     );
  //   },
  //   [setManualFile]
  // );

  function CustomToolbar(props) {
    return (
      <GridToolbarContainer {...props}>
        <GridToolbarColumnsButton
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        <GridToolbarFilterButton
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        <GridToolbarDensitySelector
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        {/* <GridToolbarExport /> */}
        <GridToolbarExport
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        <Button
          onClick={() => {
            setUploadSignDialog(true);
          }}
          startIcon={<CloudUploadIcon />}
        >
          Upload Manually Signed BOL
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  return (
    <>
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4} sx={{ fontSize: "0.9rem" }}>
            <div>
              <OutlinedInput
                name="po-number"
                placeholder="Enter PO Number"
                fullWidth
                inputProps={{
                  style: {
                    height: "0.3rem",
                  },
                }}
                value={poNumber}
                onChange={(e) => {
                  setPoNumber(e.target.value);
                  setLoadDate({
                    fromDate: '',
                    toDate: '',
                  });
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={4} sx={{ fontSize: "0.9rem" }}>
            <div>
              <OutlinedInput
                name="bol-number"
                placeholder="Enter BOL Number"
                fullWidth
                inputProps={{
                  style: {
                    height: "0.3rem",
                  },
                }}
                value={bolNumber}
                onChange={(e) => {
                  setBolNumber(e.target.value);
                  setLoadDate({
                    fromDate: '',
                    toDate: '',
                  });
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={4} sx={{ fontSize: "0.9rem" }}>
            <div>
              <OutlinedInput
                name="load-id"
                placeholder="Enter Load ID"
                fullWidth
                inputProps={{
                  style: {
                    height: "0.3rem",
                  },
                }}
                value={loadId}
                onChange={(e) => {
                  setLoadId(e.target.value);
                  setLoadDate({
                    fromDate: '',
                    toDate: '',
                  });
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div>
              <DateRangePicker
                initialSettings={{
                  startDate: loadDate.fromDate
                    ? loadDate.fromDate
                    : moment().toDate(),
                  endDate: loadDate.toDate
                    ? loadDate.toDate
                    : moment().toDate(),
                }}
                onCallback={handleCallback}
              >
                <div id="reportrange" className="box-with-icon filterCalendar">
                  <span
                    style={{
                      fontSize: "0.8rem",
                      paddingTop: "3px",
                      color: loadDate.fromDate
                        ? "rgba(0, 0, 0, 0.87)"
                        : "#636c72",
                    }}
                  >
                    {labelLoadDate}
                  </span>
                  <CalendarMonthOutlinedIcon />
                </div>
              </DateRangePicker>
            </div>
          </Grid>

          <Grid item xs={12} md={12}>
            <Stack direction="row" spacing={2}>
              <Button
                color="grey"
                variant="contained"
                onClick={clearForm}
                size="small"
              >
                Reset
              </Button>
              <Button variant="contained" onClick={handleSearch} size="small">
                Apply Filter
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </div>
      {/* <div>
        <form onSubmit={handleSearch}>
          <Grid container spacing={1} sx={{ marginTop: "15px" }}>
            <Grid item xs={12} md={2.5}>
              <div>
                <DateRangePicker
                  initialSettings={{
                    startDate: loadDate.fromDate
                      ? loadDate.fromDate
                      : moment().toDate(),
                    endDate: loadDate.toDate
                      ? loadDate.toDate
                      : moment().toDate(),
                  }}
                  onCallback={handleCallback}
                >
                  <div
                    id="reportrange"
                    className="box-with-icon filterCalendar"
                  >
                    <span
                      style={{
                        fontSize: "0.8rem",
                        paddingTop: "3px",
                        color: loadDate.from_mustArriveByDt
                          ? "rgba(0, 0, 0, 0.87)"
                          : "#636c72",
                      }}
                    >
                      {labelLoadDate}
                    </span>
                    <CalendarMonthOutlinedIcon />
                  </div>
                </DateRangePicker>
              </div>
            </Grid>
            <Grid item xs={12} md={0.9}>
              <Stack direction="row" spacing={0}>
                <IconButton
                  aria-label="submit"
                  color="primary"
                  type="submit"
                  onClick={handleSearch}
                >
                  <SearchIcon />
                </IconButton>
                <IconButton
                  aria-label="clear"
                  color="secondry"
                  onClick={clearForm}
                >
                  <ClearIcon />
                </IconButton>
              </Stack>
            </Grid>
          </Grid>
        </form>
      </div> */}
      <div
        style={{
          height: 700,
          width: "100%",
          marginTop: "20px",
          background: "#fff",
        }}
      >
        <DataGridPremium
          loading={isLoading}
          slots={{ toolbar: CustomToolbar }}
          apiRef={apiRef}
          //cellSelectionModel={cellSelectionModel}
          onCellSelectionModelChange={handleCellSelectionModelChange}
          cellSelection={true}
          //onRowClick={handlerRowClick}
          columns={columns}
          rows={rowsData}
          sx={{ flex: 1, "& .MuiButton-text": { fontSize: "14px" } }}
          pagination
          pageSizeOptions={[30, 50, 100, 200]}
          // initialState={{pagination: { paginationModel: { pageSize: 50 } }}}
        ></DataGridPremium>

        {open && (
          <Dialog
            id="signDialog"
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="form-dialog-title"
            style={{
              height: "100%",
              width: "100%",
              alignItems: "left",
            }}
            fullWidth={true}
            maxWidth={"md"}
          >
            <DialogTitle
              className="colordivSumHead font-bold"
              id="form-dialog-title"
            >
              Order No: {orderNo}
            </DialogTitle>
            <DialogContent>
              <PDFViewer
                fileName={signedFileName}
                action={() => {}}
                isSigned={isSigned}
                showSign={false}
                orderNo={orderNo}
              />
            </DialogContent>
          </Dialog>
        )}

        {formDialog && (
          <Dialog
            open={formDialog}
            onClose={() => setFormDialog(false)}
            PaperProps={{
              component: "form",
            }}
            maxWidth="sm"
            fullWidth={true}
          >
            <DialogTitle>Upload Files</DialogTitle>
            <DialogContent>
              {dataSaved && (
                <Alert
                  icon={<CheckIcon fontSize="inherit" />}
                  severity="success"
                >
                  Data Saved Succefully
                </Alert>
              )}
              {error && (
                <Alert icon={<CheckIcon fontSize="inherit" />} severity="error">
                  {errorMessage}
                </Alert>
              )}
              <Box sx={{ marginBottom: 2 }}>
                <FormControl sx={{ width: "100%" }}>
                  <FormLabel id="demo-radio-buttons-group-label">
                    MBOL Number
                  </FormLabel>
                  <TextField
                    variant="outlined"
                    placeholder="MBOL Number"
                    onChange={handleMbolNumber}
                    value={mBolNo}
                    fullWidth
                  />
                </FormControl>
              </Box>
              <Box sx={{ marginBottom: 2 }}>
                <FormControl sx={{ width: "100%" }}>
                  <FormLabel id="demo-radio-buttons-group-label">
                    MBOL File
                  </FormLabel>
                  <TextField
                    variant="outlined"
                    placeholder="MBOL File"
                    onChange={handleMbolFile}
                    type="file"
                    inputProps={{
                      multiple: false,
                      accept: "application/pdf",
                    }}
                    fullWidth
                    error={mBolError}
                    helperText={mBolError ? "MBol Number is Duplicate" : ""}
                  />
                </FormControl>
              </Box>
              <Box sx={{ marginBottom: 2 }}>
                <FormControl sx={{ width: "100%" }}>
                  <FormLabel id="demo-radio-buttons-group-label">
                    BOL Number *
                  </FormLabel>
                  <TextField
                    variant="outlined"
                    placeholder="BOL Number"
                    onChange={handleBolNumber}
                    value={bolNo}
                    required
                    fullWidth
                    helperText={bolError ? "Bol Number is Required" : ""}
                    error={bolError}
                  />
                </FormControl>
              </Box>
              <Box>
                <FormControl sx={{ width: "100%" }}>
                  <FormLabel id="demo-radio-buttons-group-label">
                    BOL File
                  </FormLabel>
                  <TextField
                    variant="outlined"
                    placeholder="BOL File"
                    onChange={handleBolFiles}
                    type="file"
                    inputProps={{
                      multiple: false,
                      accept: "application/pdf",
                    }}
                    fullWidth
                  />
                </FormControl>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setFormDialog(false)}
                sx={{ fontSize: "13px" }}
                variant="outlined"
              >
                Cancel
              </Button>
              <Button
                type="button"
                disabled={bolError}
                onClick={handleUploadMultiFiles}
                sx={{ fontSize: "13px" }}
                variant="contained"
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {openSignature && (
          <Dialog
            id="signDialog"
            open={openSignature}
            onClose={() => setOpenSignature(false)}
            aria-labelledby="form-dialog-title"
            style={{
              height: "100%",
              width: "100%",
              alignItems: "left",
            }}
            fullWidth={true}
            maxWidth={"lg"}
          >
            <DialogTitle
              className="colordivSumHead font-bold"
              id="form-dialog-title"
            >
              Please add your digital signature:-
            </DialogTitle>
            <DialogContent>
              {isErrorMsg && (
                <Alert severity="error">
                  This will remove existing signature from this file. Are you
                  sure you want to re-sign?
                </Alert>
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "15px",
                }}
              >
                <Box>
                  Shipper Signature
                  <Box
                    sx={{
                      background: "#f5f4f4",
                      border: "2px dashed #c2c2c2",
                      borderRadius: "8px",
                      marginTop: "10px",
                    }}
                  >
                    <SignatureCanvas
                      canvasProps={{
                        width: 550,
                        height: 200,
                        className: "sigCanvas",
                      }}
                      ref={signatureCanvasRef2}
                    />
                  </Box>
                </Box>
                <Box>
                  Carrier Signature
                  <Box
                    sx={{
                      background: "#f5f4f4",
                      border: "2px dashed #c2c2c2",
                      borderRadius: "8px",
                      marginTop: "10px",
                    }}
                  >
                    <SignatureCanvas
                      canvasProps={{
                        width: 550,
                        height: 200,
                        className: "sigCanvas",
                      }}
                      ref={signatureCanvasRef}
                    />
                  </Box>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClearSignature} >Clear</Button>
              <Button onClick={handleSavePDF} disabled={isDisabled}>Save</Button>
            </DialogActions>
          </Dialog>
        )}

        {uploadSignDialog && (
          <Dialog
            id="uploadSignDialog"
            open={uploadSignDialog}
            onClose={() => setUploadSignDialog(false)}
            aria-labelledby="form-dialog-title"
            style={{
              height: "100%",
              width: "100%",
              alignItems: "left",
            }}
            fullWidth={true}
            maxWidth={"lg"}
          >
            <DialogTitle
              className="colordivSumHead font-bold"
              id="form-dialog-title"
            >
              Manual upload your signature:-
            </DialogTitle>
            <DialogContent>
              {rowSelectionModel.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    marginBottom: "15px",
                    justifyContent: "flex-end",
                  }}
                >
                  <TextField
                    type="file"
                    variant="outlined"
                    inputProps={{ multiple: false, accept: "application/pdf" }}
                    onChange={handleManualFile}
                  />
                  <Button
                    onClick={uploadManualFile}
                    startIcon={<CloudUploadIcon />}
                    variant="contained"
                    sx={{ marginLeft: "10px" }}
                    disabled={isDisabled}
                  >
                    Upload
                  </Button>
                </Box>
              )}
              <Box sx={{ width: "100%", height: "30%" }}>
                <DataGridPremium
                  apiRef={apiRefManual}
                  columns={mainColumns}
                  rows={rowsData}
                  checkboxSelection
                  disableRowSelectionOnClick
                  onRowSelectionModelChange={(newRowSelectionModel, detail) => {
                    let newModel = [];
                    if (newRowSelectionModel.length === 1) {
                      setRowSelectionModel(newRowSelectionModel);
                    } else if (
                      newRowSelectionModel.length > rowSelectionModel.length
                    ) {
                      const newOwner = detail.api.getRow(
                        newRowSelectionModel[newRowSelectionModel.length - 1]
                      ).Owner;
                      const newWareHouse = detail.api.getRow(
                        newRowSelectionModel[newRowSelectionModel.length - 1]
                      ).Warehouse;

                      const oldOwner = detail.api.getRow(
                        rowSelectionModel[0]
                      ).Owner;
                      const oldWarereHouse = detail.api.getRow(
                        rowSelectionModel[0]
                      ).Warehouse;

                      if (
                        newOwner === oldOwner &&
                        newWareHouse === oldWarereHouse
                      ) {
                        setRowSelectionModel(newRowSelectionModel);
                      } else {
                        alert(
                          "Orders with different Owner/Warehouse can not be selected !!"
                        );
                      }
                    } else {
                      setRowSelectionModel(newRowSelectionModel);
                    }
                  }}
                  rowSelectionModel={rowSelectionModel}
                  isRowSelectable={(params) => !params.row.isBOLSigned}
                  pagination
                  pageSizeOptions={[30, 50, 100, 200]}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 50 } },
                  }}
                  sx={{
                    "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer":
                      {
                        display: "none",
                        backgroundColor: "rgb(103 130 219)",
                      },
                  }}
                />
              </Box>
            </DialogContent>
          </Dialog>
        )}
      </div>
    </>
  );
};

export default EsignBolTable;
